<template>
  <div class="tablediv box">
    <div class="box_f1 box box_v">
      <dv-decoration-7>　{{title}}　</dv-decoration-7>
      <div class="box_f1">
        <dv-border-box-8>
          <dv-scroll-board :config="config" />
        </dv-border-box-8>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'csscAllTable',
    computed: {
      xiaofeiquanVue() {
        return this.$store.state.xiaofeiquanVue
      },
    },
    created() {
      this.config = this.getConfig([['', '', '', '']])
      //4大类总消费金额排名
      //04--超市，05--商场,06--家电，07--金银珠宝,
      let resobj = {
        '04':{"isSucceed":true,"message":"","rows":[{"companyName":"河北美食林商贸集团有限公司滏东购物广场(美食林滏东购物广场)","goodsAmount":425824.85,"consumeNum":3874},{"companyName":"邯郸市阳光超市有限公司新世纪店-超市","goodsAmount":353144.83,"consumeNum":3202},{"companyName":"河北美食林商贸集团有限公司新宇购物广场(美食林新宇购物广场)","goodsAmount":332734.48,"consumeNum":3003},{"companyName":"河北美食林商贸集团有限公司新城购物广场-超市","goodsAmount":300551.30,"consumeNum":2763},{"companyName":"邯郸市阳光超市有限公司前进店（前进店)","goodsAmount":280647.55,"consumeNum":2427},{"companyName":"","goodsAmount":277057.81,"consumeNum":2527},{"companyName":"邯郸市阳光超市有限公司万达店","goodsAmount":228832.71,"consumeNum":2090},{"companyName":"天鸿店-阳光超市","goodsAmount":211846.73,"consumeNum":1922},{"companyName":"河北美食林商贸集团有限公司邯郸鑫港分公司(美食林鑫港购物广场)","goodsAmount":188395.16,"consumeNum":1659},{"companyName":"河北美食林商贸集团有限公司千百家分公司","goodsAmount":184877.41,"consumeNum":1692}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '07':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸阳光新世纪股份有限公司-金银珠宝","goodsAmount":1104048.04,"consumeNum":298},{"companyName":"邯郸市赵都黄金珠宝有限公司","goodsAmount":572793.70,"consumeNum":155},{"companyName":"邯郸万达工贸有限公司—金银珠宝","goodsAmount":511713.00,"consumeNum":156},{"companyName":"邯郸市阳光新龙商贸有限公司天鸿广场分公司-金银珠宝","goodsAmount":114547.00,"consumeNum":22}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '06':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸市阳光三联电器有限公司-家电","goodsAmount":16863598.20,"consumeNum":13281},{"companyName":"邯郸苏宁易购商贸有限公司","goodsAmount":3943194.30,"consumeNum":3487},{"companyName":"邯郸苏宁易购商贸有限公司丛台稽山新天地店","goodsAmount":2884845.60,"consumeNum":2508},{"companyName":"邯郸苏宁易购商贸有限公司丛台区美乐城店","goodsAmount":2113674.70,"consumeNum":1868},{"companyName":"","goodsAmount":490400.00,"consumeNum":363},{"companyName":"邯郸市康德超级市场有限公司—家电","goodsAmount":283790.00,"consumeNum":264}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '05':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸万达工贸有限公司—百货餐饮","goodsAmount":7192324.60,"consumeNum":51249},{"companyName":"邯郸阳光新世纪股份有限公司-百货餐饮","goodsAmount":5802156.25,"consumeNum":26211},{"companyName":"邯郸市丛台区国风购物中心","goodsAmount":3495501.70,"consumeNum":30192},{"companyName":"邯郸市阳光新龙商贸有限公司天鸿广场分公司-百货餐饮","goodsAmount":2914133.32,"consumeNum":17039},{"companyName":"邯郸市阳光三联电器有限公司-百货餐饮","goodsAmount":979698.10,"consumeNum":6652},{"companyName":"邯郸市康德超级市场有限公司—百货餐饮","goodsAmount":800396.00,"consumeNum":6240},{"companyName":"邯郸市阳光超市有限公司人民路分公司-百货.餐饮","goodsAmount":645353.70,"consumeNum":5027},{"companyName":"邯郸市千汇商业管理有限公司美食林御美购物广场","goodsAmount":447912.00,"consumeNum":2831},{"companyName":"邯郸市美乐百货管理有限公司(美乐百货)","goodsAmount":364199.10,"consumeNum":2503},{"companyName":"河北美食林商贸集团有限公司滏东购物广场","goodsAmount":346892.80,"consumeNum":3085}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
      }

      // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/top',{
      //   discountCouponTypeNO: this.type
      // },res=> {
      {
        let res = resobj[this.type]
        let data = res.rows.map(item=> {
          return ['<span title="'+item.companyName+'">'+item.companyName+'</span>',
            '<span title="'+item.goodsAmount+'">'+this.toThousands(item.goodsAmount, true)+'</span>',
            '<span title="'+item.consumeNum+'">'+this.toThousands(item.consumeNum, true)+'</span>']
        })
        this.config = this.getConfig(data)
      }
    },
    methods: {
      getConfig(data) {
        if(data.length<1) {
          data = [['', '', '', '']]
        }
        return {
          header: ['企业名称', '消费总金额(元)', '核销总数(张)'],
          data: data,
          index: true,
          waitTime: 3000,
          headerBGC: 'rgba(29, 193, 245,.5)',
          oddRowBGC: '',
          evenRowBGC: '',
          columnWidth: [50, 230],
          align: ['center', 'left', 'center','center']
        }
      },
      toThousands(_num, bol) {
        _num = _num.toFixed(4)*1
        let numArr = (_num+'').split('.')
        let num = parseInt(numArr[0])
        let xs = numArr[1]?numArr[1]:''

        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(xs) {
          result = [...result, '.', ...xs.split('')]
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      },
      _toThousands(num, bol) {
        num = parseInt(num)
        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      }
    },
    data () {
      return {
        config: {}
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less">
  .tablediv {
    position: relative;
    width: 100%;
    height: 50%;

    .dv-scroll-board {
      height: 100%;
    }
    .dv-border-box-8 {
      .border-box-content {
        padding: 10px!important;
      }
    }
    .dv-decoration-7 {
      height: 25px;
      margin: 20px 0px!important;
      font-size: 16px;
    }
  }
</style>
